import React, { Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'
import styled from 'styled-components'
import GoogleAnalyticsReporter from '../components/analytics/GoogleAnalyticsReporter'
import Header from './Header'
import Polling from '../components/Header/Polling'
import URLWarning from '../components/Header/URLWarning'
import Popups from '../components/Popups'
import Web3ReactManager from '../components/Web3ReactManager'
import DarkModeQueryParamReader from '../theme/DarkModeQueryParamReader'

//NFT IMPORTS
import NFTMarketPlace from './NFTMarketPlace/pages/Market/NFTMarketPlace'
import NFTItemDetail from './NFTMarketPlace/pages/Market/NFTItemDetail'
import NFTCreate from './NFTMarketPlace/pages/Create/NFTCreate/NFTCreate'
import NFTProfile from './NFTMarketPlace/pages/Profile/NFTProfile'
import NTFCreateERC721 from './NFTMarketPlace/pages/Create/NFTCreateERC721/NTFCreateERC721'
import NFTCollection from './NFTMarketPlace/pages/Collection/NFTCollection'
import NFTSummerCollection from './NFTSummerCollection'
import HeartNftSale from './NFTMarketPlace/pages/NFTSale/HeartNftSale'
import Activity from './NFTMarketPlace/pages/Activity'
import NFTStake from './NFTMarketPlace/pages/Stake'
import NFTStakeManage from './NFTMarketPlace/pages/Stake/Manage/Manage'
import AccountDetails from './NFTMarketPlace/pages/AccountDetails'
import Graphic from '../assets/svg/Graphic.svg'
import Dashboard from './NFTMarketPlace/pages/Dashboard'
import ProfilePage from './NFTMarketPlace/pages/ProfilePage'
import CollectionPage from './NFTMarketPlace/pages/CollectionPage'
import SideBar from './SideBar'
import CreatePage from './NFTMarketPlace/pages/CreatePage'
import { Helmet } from 'react-helmet'
import SalePage from './NFTMarketPlace/pages/SalePage'
import SummerCollectionSalePage from './NFTMarketPlace/pages/SalePage/SummerCollectionSalePage'
import { useURLWarningToggle } from '../state/user/hooks'


const AppWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  overflow-x: hidden;
  height: 100%;
  //background-color: ${({ theme }) => theme.newBg1};
  // background-image: url('${Graphic}');
  // background-repeat: no-repeat;
  // background-size: cover;
`

const HeaderWrapper = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  width: 100%;
  justify-content: space-between;
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  //padding-top: 25px;
  align-items: center;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 10;
  height: 100%;
  background-color: ${({ theme }) => theme.pageBg};

  // ${({ theme }) => theme.mediaWidth.upToLarge`
  //   flex: unset;
  //   height: calc(100% - 120px);
  // `};

 

  z-index: 1;
`

const BodyInner = styled.div`
  height: 100%;
  width: 100%;
  display:flex;
  align-items: center;
  justify-content: center;
  ${({ theme }) => theme.mediaWidth.upToSmall`
  //padding: 16px;
  //padding-top: 2rem;
  `};
`;

const Marginer = styled.div`
  margin-top: 5rem;
`

const SideWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  `;

// Diagnal beta badge
const BetaBadge = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: #3cb55b;
  color: ${({ theme }) => theme.text1};
  padding: 0.5rem;
  border-radius: 0.5rem;
  font-size: 0.8rem;
  font-weight: bold;
  z-index: 10;
  width: 100px;
  transform: rotate(-45deg);
  text-align: center;
  margin-left: -35px;
  margin-top: -5px;
`;

export default function App() {
  const [isSiderbarOpen, setSiderbarOpen] = React.useState(false);
  const onClickSideMenu = () => {
    setSiderbarOpen(!isSiderbarOpen);
  }

  const onToggleSidebar = (visible: boolean) => {
    setSiderbarOpen(visible);
  }

  return (
    <Suspense fallback={null}>
      <Route component={GoogleAnalyticsReporter} />
      <Route component={DarkModeQueryParamReader} />
      <Helmet>
        <title>{"YetiSwap NFT Marketplace"}</title>
      </Helmet>
      <AppWrapper id='appWrapper'>
        <URLWarning />
        {/* <HeaderWrapper>
          <Header />
          
        </HeaderWrapper> */}
        <SideWrapper>
          <SideBar onToggle={onToggleSidebar} isOpen={isSiderbarOpen} />
          <BodyWrapper id="bodyWrapper">
            <Header onClickMenu={onClickSideMenu} />
            <Popups />
            <Polling />
            <BodyInner>
              <Web3ReactManager>
                <Switch>

                  {/*NFT ROUTES*/}
                  <Route exact strict path="/yts-summer-collection" component={SummerCollectionSalePage} />
                  {/* <Route exact strict path="/yeti-summer-nft-collection" component={NFTSummerCollection} /> */}
                  {/* <Route exact strict path="/heart-nft-sale" component={HeartNftSale} /> */}
                  <Route exact strict path="/explore" component={NFTMarketPlace} />
                  <Route exact strict path="/nft-stake" component={NFTStake} />
                  <Route exact strict path="/nft-stake/:contractAddress" component={NFTStakeManage} />
                  <Route exact strict path="/nft-detail/:tokenContract/:tokenId" component={NFTItemDetail} />
                  <Route exact strict path="/nft-create" component={CreatePage} />
                  <Route exact strict path="/nft-create/erc721" component={NTFCreateERC721} />
                  <Route exact strict path="/profile/wallet" component={ProfilePage} />
                  <Route exact strict path="/profile/:accountParam" component={ProfilePage} />
                  <Route exact strict path="/collection/:tokenContract" component={CollectionPage} />
                  <Route exact strict path="/activities" component={Activity} />
                  <Route exact strict path="/account-details" component={AccountDetails} />
                  <Route exact strict path="/sales/:saleName" component={SalePage} />

                  <Route path="/" component={Dashboard} />

                </Switch>
              </Web3ReactManager>
            </BodyInner>
            {/* <Marginer /> */}
          </BodyWrapper>
        </SideWrapper>
      </AppWrapper>

    </Suspense>
  )
}
